<template>
    <div>
        <nav-breadcrumb :menu="[{label:  '债转详情'}]"/>

        <el-row>
            <el-col>
                <panel label="基本信息" >
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="180px">
                        <el-row>
                            <panel border>
                            <el-col :span="12">
                                <el-form-item label="债转编号：" style="width: 100%">
                                    {{dataForm.t__transactionNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" style="width: 100%">
                                    &nbsp;
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="转让人：" prop="i__frContactPerson"  style="width: 100%">
                                    {{dataForm.i__frPartnerName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="法人：" prop="i__frContactPerson" style="width: 100%" >
                                    {{dataForm.i__frContactPerson}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="转让人户名：" prop="i__frAccountName" style="width: 100%" >
                                    {{dataForm.i__frAccountName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="开户银行：" prop="i__frBankName" style="width: 100%" >
                                    {{dataForm.i__frBankName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="银行账号：" prop="i__frAccountNo" style="width: 100%" >
                                    {{dataForm.i__frAccountNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" style="width: 100%">
                                    &nbsp;
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="受让人：" prop="i__toPartnerName" style="width: 100%">
                                    {{dataForm.i__toPartnerName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="法人：" prop="i__toContactPerson" style="width: 100%" >
                                    {{dataForm.i__toContactPerson}}
                                </el-form-item>
                            </el-col>
                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="贷款信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm2" label-width="180px">
                        <el-row>
                            <panel border>

                            <el-col :span="12">
                                <el-form-item label="贷款合同：" style="width: 100%">
                                    {{dataForm.data1}}
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="贷款期限："  style="width: 100%">
                                  {{dataForm.data2}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="客户姓名："  style="width: 100%">
                                     {{dataForm.data3}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="身份证号："  style="width: 100%">
                                    {{dataForm.data4}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款金额：" style="width: 100%">
                                    {{dataForm.t__totalAmount|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="担保合同编号："  style="width: 100%">
                                    {{dataForm.data5}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="抵押物："  style="width: 100%">
                                    {{dataForm.data6}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="已还款金额："   style="width: 100%">
                                   {{dataForm.t__repaymentAmount|formatMoney}}元  &nbsp;&nbsp;&nbsp;&nbsp;<el-button type="small" v-if="dataForm.t__referenceId" @click="showDialogTwo()">查看还款信息</el-button>
                                </el-form-item>
                            </el-col>
                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="债转信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm3" label-width="180px">
                        <el-row>
                            <panel border>

                            <el-col :span="12">
                                <el-form-item label="债转日期：" style="width: 100%"  >
                                    {{dataForm.t__transactionDate}}
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="已累计支付购买价款："   style="width: 100%">
                                    {{dataForm.t__swappedAmount|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付剩余本金："   style="width: 100%">
                                    {{dataForm.t__principalPayable|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付利息："    style="width: 100%">
                                    {{dataForm.t__interestPayable|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付罚息："   style="width: 100%">
                                    {{dataForm.t__overdueFinePayable|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付复利："    style="width: 100%">
                                    {{dataForm.t__compoundInterestPayable|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="债转合计金额：" style="width: 100%">
                                    {{dataForm.t__netEquityValue|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：" >
                                   {{dataForm.t__transactionStatus|Status2CN}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="备注：">
                                    {{dataForm.t__remarks}}
                                </el-form-item>
                            </el-col>
                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="审核流程">
                    <data-table
                        :table-data="approvalArry"
                        :columns="tableColumns"
                        :is-pagination-show="false"
                    />
                </panel>
            </el-col>
        </el-row>
        <el-dialog title="选择合同" :visible.sync="showDialogValue" width="60%" >
            <data-table :table-data="tableData" :columns="columns" :filters.sync="filters" :is-pagination-show="false"></data-table>
        </el-dialog>
        <el-dialog title="查看还款信息" :visible.sync="showDialogValue2" width="80%" >
            <data-table
                :columns="RepayColumns"
                :table-data="{data:financingDetail.repayments.filter(item=>item.re__sequenceNo) }"
                :is-pagination-show="false"
            >
            </data-table>
        </el-dialog>
        <div class="tr xzmt">
            <el-button @click="$router.back()">返回</el-button>
        </div>
    </div>
</template>

<script>
    import Status2CN from "../../filters/Status2CN";
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import moment from 'moment'
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "EquitySwapTxAdd",
        data(){
            return {
                financingDetail :{
                    repayments:[],
                },
                approvalArry: {
                    data: [],
                    count: 0,
                },
                tableColumns: [
                    {
                        label: '操作时间',
                        field: 'time',
                        formatter: function (r, c, v) {
                            return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
                        }
                    },
                    {
                        label: '操作人',
                        field: 'approverName'
                    },
                    {
                        label: '操作结果',
                        field: 'status'
                    },
                    {
                        label: '操作备注',
                        field: 'remarks'
                    },

                ],
                RepayColumns:[
                    {
                        label:'期数',
                        field:'re__sequenceNo'
                    },
                    {
                        label: '应还款日',
                        field: 'plan__repayDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '实还款日',
                        field: 're__repayDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '到账金额',
                        field: 're__repayAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还本金',
                        field: 're__principalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还利息',
                        field: 're__interestAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还罚息',
                        field: 're__overdueFine',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还复利',
                        field: 're__compoundInterest',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    /*{
                    label: '提前还款违约金',
                    field: 're__penaltyAmount',
                    formatter: function (r,c,v) {
                    return formatMoney(v)+'元'
                    }
                    },*/
// {
//   label: '服务费',
//   field: 're__lendingFeeAmount',
//   formatter: function (r,c,v) {
//     return formatMoney(v)+'元'
//   }
// },
                    /* {
                    label: '其他费用',
                    field: 're__otherAmount',
                    formatter: function (r,c,v) {
                    return formatMoney(v)+'元'
                    }
                    },*/
                    {
                        label: '减免金额',
                        field: 're__deductionAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '上期余额',
                        field: 're__exBalanceAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '本期余额',
                        field: 're__excessAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },


                ],
                showDialogValue2:false,
                repaymentAmount:0,
                tableData: {
                    count: 0,
                    data: []
                },
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '合同编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户名称',
                        field: 'ba__customerName'
                    },
                    {
                        label: '担保合同编号',
                        field: 'docs__warrantNo'
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '选择',
                                class: 'el-icon-finished',
                                clickHandler: (index, row)=> {
                                    this.dataForm.t__referenceId = row.fi__transactionId
                                    this.dataForm.data1 = row.fi__transactionNo
                                    this.dataForm.data2 = row.fi__startDate + '~' + row.fi__endDate
                                    this.dataForm.data3 = row.ba__customerName
                                    this.dataForm.data4 = row.ba__customerIC
                                    this.dataForm.t__totalAmount = row.fi__totalAmount
                                    this.dataForm.data5 = row.docs__warrantNo
                                    this.dataForm.data6 = row.pr__propertyLocation

                                    this.dataForm.t__principalPayable = row.re__advancedPrincipalAmount
                                    this.dataForm.t__interestPayable = row.re__advancedInterestAmount
                                    this.dataForm.t__overdueFinePayable = row.re__advancedOverdueFine
                                    this.dataForm.t__compoundInterestPayable = row.re__advancedCompoundInterest
                                   this.changeValue()
                                    this.showDialogValue = false
                                }
                            },
                        ]
                    }

                ],
                olumns:[
                    {
                        label: '序号',
                        field: 'ow__lineNo',
                        component: 'el-input',
                        type: 'number',
                        span:24
                    },
                    {
                        label: '姓名',
                        field: 'ow__ownerName',
                        component: 'el-input',
                        type: 'text',
                    },
                    {
                        label: '身份证号',
                        field: 'ow__ownerIC',
                        component: 'el-input',
                        type: 'text',
                    },
                    {
                        label: '手机号',
                        field: 'ow__ownerContactNo',
                        component: 'el-input',
                        span:24
                    },
                    {
                        label: '住所地址',
                        field: 'ow__ownerAddress',
                        component: 'el-input',
                        span:24
                    },
                ],
                showCol : true,
                showDialogValue:false,
                transactionId: this.$route.query['transactionId']||'',
                dataForm:{
                    t__transactionNo:'待生成',
                    t__transactionStatus: 'YZZ',
                    t__principalPayable:0,
                    t__interestPayable:0,
                    t__overdueFinePayable:0,
                    t__compoundInterestPayable:0,
                    t__repaymentAmount:0,
                    t__swappedAmount:0,
                    data1:'',
                    data2:'',
                    data3:'',
                    data4:'',
                    data5:'',
                    data6:''
                },
                partnerOptions1:[
                ],
                partnerOptions2:[
                ],
                disabledOptions:[
                    {
                        label:'启用',
                        value:'N'
                    },
                    {
                        label:'禁用',
                        value:'Y'
                    },
                ],
                dataFormRules: {
                    i__bankName: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                    i__accountName: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                    i__accountNo: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                },
                filters: {
                    labelWidth: '150px',
                    form: {
                        fi__transactionNo:'',
                        ba__customerName:'',
                        docs__warrantNo:'',
                    },
                    columns: [

                        {
                            label: '合同编号',
                            component: 'el-input',
                            field: 'fi__transactionNo'
                        },
                        {
                            label: '客户名称',
                            component: 'el-input',
                            field: 'ba__customerName'
                        },
                        {
                            label: '担保合同编号',
                            component: 'el-input',
                            field: 'docs__warrantNo'
                        },
                    ],
                    onSubmit:()=>{
                        this.getEquitySwapCandidatesSelect()
                    }
                }
            }
        },
        watch:{

        },
        filters:{
            Status2CN
        },
        mounted() {
            if(this.transactionId){
                this.getData()
            }
            this.getPartnerOptions1()
            this.getPartnerOptions2()
        },
        methods:{
            data : function () {
                xhr.getFinancingFang({
                    'fi.transactionId': this.dataForm.t__referenceId
                }, res=>{
                    try{
                        if(res.data.status == 'success') {
                            this.financingDetail = res.data.data


                        }
                    }catch(e){}
                })

            },
            changeValue :function() {
                this.dataForm.t__netEquityValue = parseFloat(this.dataForm.t__swappedAmount) + parseFloat(this.dataForm.t__principalPayable) +parseFloat(this.dataForm.t__interestPayable) +parseFloat(this.dataForm.t__overdueFinePayable)+parseFloat(this.dataForm.t__compoundInterestPayable)

            },
            showDialog: function () {
                this.showDialogValue = true
                this.getEquitySwapCandidatesSelect()
            },
            showDialogTwo: function () {
                this.showDialogValue2 = true
                this.data()
            },
            getEquitySwapCandidatesSelect : function () {
                xhr.getEquitySwapCandidatesSelect(
                    Object.assign({pageSize:0}, {}, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })
            },
            getEquitySwapCandidatesSelect2 : function (referenceId) {
                xhr.getEquitySwapCandidatesSelect(
                    Object.assign({
                        'fi.transactionId':referenceId,
                        }, {}, {}),
                    res=> {
                        try {
                            console.log(res.data.data[0].fi__transactionNo)
                            let row = res.data.data[0]

                            this.dataForm.data1 = row.fi__transactionNo
                            this.dataForm.data2 = row.fi__startDate + '至' + row.fi__endDate
                            this.dataForm.data3 = row.ba__customerName
                            this.dataForm.data4 = row.ba__customerIC
                            this.dataForm.data5 = row.fi__warrantNo
                            this.dataForm.data6 = row.fi__propertyLocation

                        }catch(e){

                        }
                    })
            },
            getPartnerOptions1: function () {
                xhr.getPartnerOptions(
                    Object.assign({
                        'partnerType':'ZRR'
                    }, {}, {}),
                    res=> {
                        try {
                            this.partnerOptions1 = res.data.data.map(item=>{
                                return {
                                    label: item.p__partnerName,
                                    value:item.p__partnerId,
                                    p__contactPerson:item.p__contactPerson,
                                    i__accountName:item.i__accountName,
                                    i__bankName:item.i__bankName,
                                    i__accountNo:item.i__accountNo,
                                    i__contactNo:item.i__contactNo,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getPartnerOptions2: function () {
                xhr.getPartnerOptions(
                    Object.assign({
                        'partnerType':'SRR'
                    }, {}, {}),
                    res=> {
                        try {
                            this.partnerOptions2 = res.data.data.map(item=>{
                                return {
                                    label: item.p__partnerName,
                                    value:item.p__partnerId,
                                    p__contactPerson:item.p__contactPerson,
                                    i__accountName:item.i__accountName,
                                    i__bankName:item.i__bankName,
                                    i__accountNo:item.i__accountNo,
                                    i__contactNo:item.i__contactNo,
                                }
                            })
                        }catch(e){

                        }
                    })

            },

            getData:function(){
                xhr.getEquitySwapTx({
                        't.transactionId': this.transactionId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {

                                let  dataForm = res.data.data
                                if(dataForm.data1){

                                }else{
                                    dataForm.data1 = null
                                }
                                if(dataForm.data2){

                                }else{
                                    dataForm.data2 = null
                                }
                                if(dataForm.data3){

                                }else{
                                    dataForm.data3 = null
                                }
                                if(dataForm.data4){

                                }else{
                                    dataForm.data4 = null
                                }
                                if(dataForm.data5){

                                }else{
                                    dataForm.data5 = null
                                }
                                if(dataForm.data6){

                                }else{
                                    dataForm.data6 = null
                                }
                                this.dataForm = dataForm
                                this.dataForm.approvals.forEach(item=>{
                                    this.approvalArry.data.push(
                                        {
                                            approverName: item.a__approverName,
                                            time:item.a__approvingDate,
                                            status: item.a__approvingStatus?Status2CN('TX__'+item.a__approvingStatus):'',
                                            remarks:item.a__remarks,
                                        }
                                    )
                                })
                                this.getEquitySwapCandidatesSelect2(this.dataForm.t__referenceId)
                            }
                        }catch (e) {

                        }
                    })
            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.$refs['dataForm2'].validate(valid2=> {
                            if (valid2) {
                                this.$refs['dataForm3'].validate(valid3=> {
                                    if (valid3) {
                                        dataForm.t__checked = true
                                        xhr.updateEquitySwapTx(dataForm, res=> {
                                            try {
                                                if (res.data.status == 'success') {
                                                    this.$router.push({
                                                            name: 'EquitySwapTxList'
                                                    })
                                                }
                                            } catch (e) {

                                            }
                                        })
                                    }
                                })

                            }
                        })

                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/EquitySwapTxView.vue